import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useLoadingStore = defineStore('loading', () => {
  const loadingCount = ref(0);
  const isLoading = ref(false);

  const startLoading = () => {
    loadingCount.value++;
    isLoading.value = true;
  };

  const stopLoading = () => {
    loadingCount.value--;
    if (loadingCount.value <= 0) {
      loadingCount.value = 0;
      isLoading.value = false;
    }
  };

  return { isLoading, startLoading, stopLoading };
});